import { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

let player = null;

export const CallsNotifications = () => {
  const calls = useSelector((store) => store.calls.calls, shallowEqual);

  useEffect(() => {
    // console.log('🚀 ~ useEffect ~ sounds:', calls);
    const waiting = Object.keys(calls).filter((source_id) => calls[source_id].status === 'wait');
    if (waiting.length) {
      startPlay();
    } else {
      stopPlay();
    }

    return () => {
      // stopPlay();
    };
  }, [calls]);

  /**
   * stop audio
   * @param {*} id
   */
  const stopPlay = () => {
    if (player) {
      player.pause();
      player.currentTime = 0.0;
      player = null;
    }
  };

  /**
   * play audio
   * @param {*} id
   */
  const startPlay = () => {
    if (player) {
      return;
    }
    player = new Audio('/audio/call.mp3');
    player.loop = true;
    try {
      player.play().catch((error) => {
        console.log('Audio play error:', error);
      });
    } catch (error) {
      console.log('Audio play error:', error);
    }
  };

  return null;
};
